import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper, Typography } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

const DashboardPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    ownCompanies,
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    setActiveCompanyId,
    //...otherProps
  }=props
  const classes = useStyles();
  const [pricingOpen,setPricingOpen]=React.useState(false)
  const [openNewCompany,setOpenNewCompany]=React.useState(false)
  const [creatingNewCompany,setCreatingNewCompany]=React.useState(false)
  const [newCompanyType,setNewCompanyType]=React.useState("")
  
  
  function saveNewCompany(){
    var dcompanyName,dcompanyAddress,dcompanyTown,dcompanyPhone,dcompanyEmail,dcompanyNPWP
    var companyName,companyAddress,companyTown,companyPhone,companyEmail,companyNPWP
    
    dcompanyName=document.getElementById("companyName")
    dcompanyAddress=document.getElementById("companyAddress")
    dcompanyTown=document.getElementById("companyTown")
    dcompanyPhone=document.getElementById("companyPhone")
    dcompanyEmail=document.getElementById("companyEmail")
    dcompanyNPWP=document.getElementById("companyNPWP")

    companyName=dcompanyName.value||""
    companyAddress=dcompanyAddress.value||""
    companyTown=dcompanyTown.value||""
    companyPhone=dcompanyPhone.value||""
    companyEmail=dcompanyEmail.value||""
    companyNPWP=dcompanyNPWP.value||""
    console.log(newCompanyType+" | "+companyName+" | "+companyAddress+" | "+companyTown+" | "+companyPhone+" | "+companyEmail+" | "+companyNPWP)
    if(!newCompanyType||!companyName ||!companyAddress ||!companyTown ||!companyPhone ||!companyEmail){
      alert("Mohon lengkapi data")
      return
    }

    //createNewCompanyFuctions
    var createNewCompanyFuctions = firebase.fn.httpsCallable('createNewCompanyFuctions')
    setCreatingNewCompany(true)
    createNewCompanyFuctions({
      userName:currentUser.name||"",
      type:newCompanyType||"",
      name:companyName,
      address:companyAddress,
      town:companyTown,
      phone:companyPhone,
      email:companyEmail,
      NPWP:companyNPWP,
    }).then((result)=>{
      console.log("result",result.data)
      setCreatingNewCompany(false)
      setNewCompanyType("")
      setOpenNewCompany(false)
      setActiveCompanyId(result.data.company.id)
    }).catch(e=>{
      setCreatingNewCompany(false)
      alert("Gagal membuat perusahaan : "+e)
    })
    
    /*
    var companyRef=firebase.fs.collection("companies").doc()
    var companyId=companyRef.id
    var branchRef=firebase.fs.doc("companies/"+companyId+"/branches/"+companyId)
    var employeeDataRef=firebase.fs.doc("companies/"+companyId+"/branches/"+companyId+"/employeeData/"+currentUser.id)

    var companyObj={
      id:companyId,
      type:newCompanyType,
      name:companyName,
      address:companyAddress,
      town:companyTown,
      phone:companyPhone,
      email:companyEmail,
      NPWP:companyNPWP,
      owner:currentUser.id,
      deactivated:false,
    }

    var branchObj={
      ...companyObj,
      companyId:companyId,
    }

    var employeeDataObj={
      id:currentUser.id,
      joinDate:(""+serverMillis),
      position:"owner",
      name:currentUser.name||"",
      fullName:currentUser.name||"",
    }

    var batch = firebase.fs.batch();
    batch.set(companyRef, companyObj);

    batch.commit().then(()=>{
      var batch2 = firebase.fs.batch();
      batch2.set(branchRef, branchObj);
      batch2.commit().then(()=>{
        var batch3 = firebase.fs.batch();
        batch3.set(employeeDataRef,employeeDataObj)
        batch3.commit().then(()=>{
          setNewCompanyType("")
          setOpenNewCompany(false)
          setActiveCompanyId(companyObj.id)
        }).catch(e=>{
          alert("Gagal membuat employeeDAta : "+e)
        })
      }).catch(e=>{
        alert("Gagal membuat cabang : "+e)
      })
    }).catch(e=>{
      alert("Gagal membuat perusahaan : "+e)
    })
    */
  }

  function toogleCompanyEnabled(company){
    var pr=""
    if(!company.deactivated){
      pr=window.prompt("Apakah Anda yakin untuk menon-aktifkan "+company.name+"?\n\nMasukkan '"+company.name+"' untuk melanjutkan.")
      if(!pr){
        return
      }else if(pr!==company.name){
        alert("Kode tidak sesuai")
        return
      }
    }

    firebase.fs.doc("companies/"+company.id).set({
      deactivated:!company.deactivated
    },{merge:true}).then().catch(e=>{
      alert("Gagal : "+e)
    })
  }


  return (
    <div className={classes.root}>
      {sessionDomain>=1&&
        <Grid container direction={width==="xs"?"column":"row"} justify={width==="xs"?"center":"flex-start"} alignItems={width==="xs"?"stretch":"flex-start"}>
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Perusahaanku{width==="xs"?<br/>:null}
                <Button style={{float:"right"}} variant="contained" color={openNewCompany?"secondary":"primary"} disabled={creatingNewCompany} onClick={()=>{openNewCompany?saveNewCompany():setOpenNewCompany(true)}}>{openNewCompany?"Simpan":"Buat Baru"}</Button>
                {openNewCompany&&<Button style={{float:"right",marginRight:"10px"}} variant="outlined" color="primary" disabled={creatingNewCompany} onClick={()=>{setNewCompanyType("");setOpenNewCompany(false)}}>Batal</Button>}
              </Typography>
              {!openNewCompany?
                <>
                  <List style={{marginTop:width==="xs"?"50px":"10px"}}>
                    {ownCompanies.map((company,idx)=>
                      <React.Fragment key={company.id||idx}>
                        <Divider />
                        <ListItem button
                          onClick={()=>setActiveCompanyId(!!activeCompany&&activeCompany.id&&company.id===activeCompany.id?"":company.id)}>
                          <ListItemIcon>
                            {!!activeCompany&&activeCompany.id===company.id?<CheckCircleIcon />:<RadioButtonUncheckedIcon />}
                          </ListItemIcon>
                          <ListItemText
                            primary={company.name}
                            secondary={company.type}
                          />
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              color={company.deactivated?"default":"primary"}
                              onClick={()=>toogleCompanyEnabled(company)}>
                              {company.deactivated?<NotInterestedIcon />:<PowerSettingsNewIcon/>}
                            </IconButton>
                          </ListItemSecondaryAction>
                          
                        </ListItem>
                        <Divider />
                      </React.Fragment>
                    )}
                  </List>
                </>
              :
                <>
                  <FormControl required fullWidth style={{margin:"5px"}}>
                    <InputLabel id="companyTypeLabel">Tipe</InputLabel>
                    <Select
                      labelId="companyTypeLabel"
                      value={newCompanyType}
                      disabled={creatingNewCompany}
                      onChange={(ev)=>{setNewCompanyType(ev.target.value)}}
                    >
                      <MenuItem value={""}>---Pilih Tipe---</MenuItem>
                      <MenuItem value={"Finance"}>Jasa Keuangan</MenuItem>
                      <MenuItem value={"Market"}>Toko</MenuItem>
                      <MenuItem value={"Workshop"}>Bengkel</MenuItem>
                      <MenuItem value={"Production"}>Produksi</MenuItem>
                      <MenuItem value={"Restaurant"}>Restoran</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    id="companyName"
                    label="Nama Cabang"
                    placeholder=""
                    required
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                  <TextField
                    id="companyAddress"
                    label="Alamat"
                    placeholder=""
                    required
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                  <TextField
                    id="companyTown"
                    label="Kota"
                    placeholder=""
                    required
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                  <TextField
                    id="companyPhone"
                    label="Nomor Telepon"
                    placeholder=""
                    required
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                  <TextField
                    id="companyEmail"
                    label="Email"
                    placeholder=""
                    required
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                  <TextField
                    id="companyNPWP"
                    label="NPWP"
                    placeholder=""
                    disabled={creatingNewCompany}
                    fullWidth={true}
                    style={{margin:"5px"}}
                  />
                </>
              }
            </Paper>
          </Grid>
          {sessionDomain>=2&&
          <>
            <Grid item xs={12} sm={6} style={{margin:width==="xs"?"10px":"0px"}}>
                <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:"95%"}}>
                <Typography variant="h4">Laporan Bulanan</Typography>
                
                </Paper>
            </Grid>
            <Grid item xs={12} sm={6} style={{margin:width==="xs"?"10px":"0px"}}>
                <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:"95%"}}>
                <Typography variant="h4">Laporan Tahunan</Typography>
                
                </Paper>
            </Grid>
          </>}
        </Grid>
      }
    </div>
  )
}

/*

*/





const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","")(withWidth()(DashboardPage));